module.exports = __webpack_public_path__ + "img/image1.e7f3c787.png";